import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const FinancesIcon: FC<IconProps> = ({ fill, stroke, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill} stroke={stroke}>
    <g id="_6" data-name="6">
      <path
        d="M16.09,20c-1.55,0-2.83-.83-2.83-1.92s1.28-1.92,2.83-1.92,2.84.82,2.84,1.92"
        style={{
          fill: 'none',
          stroke: 'current',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.8283752901370336px',
        }}
      />
      <path
        d="M16.09,20c1.56,0,2.84.82,2.84,1.92s-1.28,1.92-2.84,1.92S13.26,23,13.26,22"
        style={{
          fill: 'none',
          stroke: 'current',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.8283752901370336px',
        }}
      />
      <line
        x1="16.09"
        y1="14.36"
        x2="16.09"
        y2="25.69"
        style={{
          fill: 'current',
          stroke: 'current',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.8283752901370336px',
        }}
      />
      <path
        d="M19.11,7.32a21.07,21.07,0,0,0,1.65-3.66c.18-1.83-.83-1.37-2.29-1.09C17.65,2.75,16.82,1,15.82,1c-1.74,0-1.92,2-3.11,1.83-2.47-.46-3,.09-2.19,1.28.91,1.37,1.92,2.38,2.37,3.2A1.2,1.2,0,0,1,12.35,9c-4.67,2.37-6.13,4.38-6.13,10.14,0,2.29-3.47,6.77-2.38,9.42,1.19,2.83,7.77,2.38,12.25,2.38,4.21,0,10,.64,11.7-1.65S26.52,24.51,26.52,22c0-5.85-2.11-10.79-6.86-13.07A1.27,1.27,0,0,1,19.11,7.32Z"
        style={{
          fill: 'none',
          stroke: 'current',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.8283752901370336px',
        }}
      />
      <path
        d="M12.25,9S15,7.5,19.75,9"
        style={{
          fill: 'current',
          stroke: 'current',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.8283752901370336px',
        }}
      />
    </g>
  </svg>
);
